import {
  Box, TableContainer, Table, TableHead, Grid,
  TableRow, TableCell, TableBody, Checkbox, FormControlLabel, FormGroup, Tooltip, Typography, IconButton
} from "@mui/material";
import SelectionBox from './selectionBox';
import Badge from './badge';
import { useState, useEffect, useCallback } from "react";
import CustomButton from 'components/Common/Button';
import { PRIMARY_BUTTON, DISABLED_BUTTON } from 'themes/theme';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import RadioButton from './radio';
import { fetchDescriptiveInfo, saveDescriptiveInfo, fetchStateContactInfo } from 'store/actions/correctYourDataActions';
import { useSelector, useDispatch } from 'react-redux';
import findLabel from './findLabel';
import Snackbar from "components/Common/SnackBar";
import ThreeDotsLoadingSpinner from 'components/Common/LoadingSpinner/threeDots';
import moment from 'moment';
import CompanyInformation from './companyInformation';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeftLong } from '@fortawesome/free-solid-svg-icons';
import findTooltipContent from "./findTooltipContent";
import eventBus from "../../utils/eventBus"
import SecretaryState from "./SecretaryState";
import ZendeskLink from 'components/Common/ZendeskLink'

const sx = {
  buttonPlacement: {
    marginTop: '30px',
    display: 'flex',
    justifyContent: 'end',
  },
  header: {
    color: '#25245f',
  },
  content: {
    color: '#66668f',
    marginTop: '10px',
    marginBottom: '10px',
  },
  arrow: {
    color: 'color.blue',
  },
  tooltip: {
    backgroundColor: 'color.blue',
  },
}

const DescriptiveInformation = ({ onDataChange }) => {
  const claimedBusiness = useSelector(state => state.apiResponseReducers.dashboardInfo.business_list)
  const descriptiveTabInfo = useSelector(state => state.correctYourDataReducer.descriptiveInformation)
  const { descriptiveInfo, descriptiveInfoCheckList } = descriptiveTabInfo
  const stateContactInfo = useSelector(state => state.correctYourDataReducer.stateContactInfo)
  // const [defaultCheckboxData, setDefaultCheckboxData] = useState(checkBoxData);
  const [updatedCheckboxData, setUpdatedCheckboxData] = useState(descriptiveInfoCheckList)
  const [bizIndicator, setbizIndicator] = useState()
  useEffect(() => {
    const bizData = descriptiveInfoCheckList.filter(val => val.label === 'BIZ_INDICATORS')
    setbizIndicator(bizData[0])
  }, [descriptiveInfoCheckList])
  const [open, setOpen] = useState(false)

  const dispatch = useDispatch()
  const [saveDisable, setDisable] = useState(true)
  const [snackData, setSnackData] = useState({
    isOpen: false,
    type: 'success',
    message: '',
  })
  useEffect(() => {
    fetchDescriptiveInfo(dispatch, claimedBusiness[0].mkz_business_id)
    fetchStateContactInfo(dispatch, claimedBusiness[0].mkz_business_id)
  }, [dispatch, claimedBusiness])
  useEffect(() => {
    setUpdatedCheckboxData(descriptiveInfoCheckList)
  }, [descriptiveInfoCheckList])

  const saveDescriptiveInformation = useCallback(() => {
    const data = {
      ...descriptiveTabInfo,
      descriptiveInfoCheckList: updatedCheckboxData,
      businessId: claimedBusiness[0].mkz_business_id,
    }
    setDisable(true)
    saveDescriptiveInfo(dispatch, data, res => saveCallback(res))
    onDataChange(false)
  }, [claimedBusiness, dispatch, updatedCheckboxData, descriptiveTabInfo, onDataChange])

  useEffect(() => {
    eventBus.on('cyd-tab-change', saveDescriptiveInformation)
    return function () {
      eventBus.off('cyd-tab-change', saveDescriptiveInformation)
    }
  }, [saveDescriptiveInformation])

  const handleBizData = val => {
    setDisable(false)
    const updatedData = descriptiveInfoCheckList.map(datum => {
      if (datum.label === val.key) {
        return {
          ...datum,
          isCorrect: val.value,
          isDataChanged: true,
        }
      } else {
        return datum
      }
    })
    dispatch({
      type: 'UPDATEDESCRIPTIVEINFO',
      payload: {
        ...descriptiveTabInfo,
        descriptiveInfoCheckList: updatedData,
      },
    })
  }

  const handleDataChange = (data, type) => {
    setDisable(false)
    onDataChange(true)
    const updatedData = descriptiveTabInfo[type].map(row => {
      if (row.label === data.label) {
        return data
      } else {
        return row
      }
    })
    dispatch({
      type: 'UPDATEDESCRIPTIVEINFO',
      payload: {
        ...descriptiveTabInfo,
        [type]: updatedData,
      },
    })
  }
  const handleCheckChange = (e, val) => {
    const { checked } = e.target
    setDisable(false)
    const updatedData = updatedCheckboxData.map(data => {
      if (data.label === val.label) {
        return {
          ...val,
          userEnteredInformation: checked ? 'Y' : 'N',
          isDataChanged: true,
        }
      } else if (data.label === 'BIZ_INDICATORS') {
        return {
          ...data,
          isDataChanged: true,
        }
      } else {
        return data
      }
    })
    setUpdatedCheckboxData(updatedData)
  }
  const saveCallback = data => {
    setSnackData(data)
    setDisable(true)
  }

  return (
    <>
      {descriptiveInfo.length ? (
        <Box>
          <Grid container>
            <SecretaryState stateContactInfo={stateContactInfo} tab="descriptive" />
            <Grid item xs={1.5} sx={sx.buttonPlacement}>
              <Box>
                <CustomButton
                  onClick={saveDescriptiveInformation}
                  type={saveDisable ? DISABLED_BUTTON : PRIMARY_BUTTON}
                >
                  Update
                </CustomButton>
              </Box>
            </Grid>
          </Grid>
          <Box className="markaazCards">
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>EXISTING INFORMATION</TableCell>
                    <TableCell align="center">
                      <Box color="#00B596">Correct</Box>
                    </TableCell>
                    <TableCell align="center">
                      <Box color="#D14343">Incorrect</Box>
                    </TableCell>
                    <TableCell align="left">UPDATED INFORMATION</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {descriptiveInfo.map(val => {
                    return (
                      <TableRow
                        key={val.label}
                        sx={{
                          'td, th': { border: 0 },
                          background: val.isCorrect === true ? '#F6FCFA' : val.isCorrect === false ? '#FDF6F6' : '#fff',
                        }}
                      >
                        <TableCell component="th" scope="row">
                          <Box>
                            <Box color="#0A78CD" fontSize="12px" fontWeight={400}>
                              {findLabel(val.label)}
                            </Box>
                            <Box
                              marginTop="5px"
                              fontSize="16px"
                              fontWeight={400}
                              color={val.publicInformation ? '#66668F' : '#BDBDCE'}
                            >
                              {val.publicInformation ? val.publicInformation : 'No data found'}
                            </Box>
                          </Box>
                        </TableCell>
                        <SelectionBox
                          data={val}
                          TooltipContent={findTooltipContent(val.label)}
                          onDataChange={changedData => handleDataChange(changedData, 'descriptiveInfo')}
                        />
                        <TableCell align="center">
                          {val.isCorrect !== null && <Badge type={val.isCorrect === true ? 'success' : 'error'} />}
                        </TableCell>
                        <TableCell align="left">
                          {val.updatedOn && (
                            <Box>
                              Updated on <br />
                              {moment(val.updatedOn).format('MM/DD/YYYY')}
                            </Box>
                          )}
                        </TableCell>
                      </TableRow>
                    )
                  })}
                  <TableRow
                    sx={{
                      'td, th': { border: 0 },
                      background:
                        bizIndicator?.isCorrect === true
                          ? '#F6FCFA'
                          : bizIndicator?.isCorrect === false
                          ? '#FDF6F6'
                          : '#fff',
                    }}
                  >
                    <TableCell component="th" scope="row">
                      <FormGroup>
                        {descriptiveInfoCheckList.map(val => {
                          if (val.label !== 'BIZ_LOGO' && val.label !== 'BIZ_INDICATORS') {
                            return (
                              <FormControlLabel
                                key={val.label}
                                control={
                                  <Checkbox
                                    disabled
                                    sx={{ '& .MuiSvgIcon-root': { fontSize: 20 } }}
                                    color="info"
                                    checked={val.publicInformation === "Y"}
                                  />
                                }
                                label={findLabel(val.label)}
                              />
                            )
                          } else {
                            return null
                          }
                        })}
                      </FormGroup>
                    </TableCell>
                    <TableCell align="right">
                      <Box display="flex" justifyContent="center">
                        <RadioButton
                          onChange={() =>
                            handleBizData({
                              value: true,
                              key: 'BIZ_INDICATORS',
                            })
                          }
                          checked={
                            bizIndicator ? (bizIndicator.isCorrect === null ? false : bizIndicator.isCorrect) : false
                          }
                          type="success"
                        />
                      </Box>
                    </TableCell>
                    <TableCell align="right">
                      <Box display="flex" justifyContent="center">
                        <RadioButton
                          onChange={() =>
                            handleBizData({
                              value: false,
                              key: 'BIZ_INDICATORS',
                            })
                          }
                          checked={
                            bizIndicator ? (bizIndicator.isCorrect === null ? false : !bizIndicator.isCorrect) : true
                          }
                          type="error"
                        />
                      </Box>
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {bizIndicator && bizIndicator.isCorrect === null ? (
                        <Box display="flex" alignItems="center" gap="10px">
                          <Box>
                            <FontAwesomeIcon fontSize="16px" className="font-weight-bold" icon={faArrowLeftLong} />
                          </Box>
                          <Box>Choose one</Box>
                        </Box>
                      ) : (
                        <FormGroup>
                          {updatedCheckboxData.map(val => {
                            if (val.label !== 'BIZ_LOGO' && val.label !== 'BIZ_INDICATORS') {
                              return (
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      key={`up${val.label}`}
                                      disabled={bizIndicator?.isCorrect}
                                      onChange={e => handleCheckChange(e, val)}
                                      sx={{ '& .MuiSvgIcon-root': { fontSize: 20 } }}
                                      color="info"
                                      checked={
                                        val[
                                          bizIndicator && bizIndicator.isCorrect
                                            ? 'publicInformation'
                                            : 'userEnteredInformation'
                                        ] === 'Y'
                                          ? true
                                          : false
                                      }
                                    />
                                  }
                                  label={findLabel(val.label)}
                                />
                              )
                            } else {
                              return null
                            }
                          })}
                        </FormGroup>
                      )}
                    </TableCell>
                    <TableCell align="center">
                      <Tooltip
                        onClick={() => (!open ? setOpen(true) : setOpen(false))}
                        onBlur={e => setOpen(false)}
                        arrow
                        componentsProps={{ tooltip: { sx: sx.tooltip }, arrow: { sx: sx.arrow } }}
                        title={
                          <Typography variant="body2">
                            Specify if your business is classified by any of the options present.
                          </Typography>
                        }
                        open={open}
                      >
                        <IconButton>
                          <InfoOutlinedIcon fontSize="large" sx={{ color: '#0099FF' }} />
                        </IconButton>
                      </Tooltip>
                    </TableCell>
                    <TableCell align="center">
                      {bizIndicator && bizIndicator.isCorrect !== null ? (
                        <Badge
                          type={
                            bizIndicator?.isCorrect === true
                              ? 'success'
                              : bizIndicator?.isCorrect === false && bizIndicator?.isMatched === true
                              ? 'success'
                              : bizIndicator?.isCorrect === false && bizIndicator?.isMatched === false && 'error'
                          }
                        />
                      ) : (
                        ''
                      )}
                    </TableCell>
                    <TableCell align="left">
                      {bizIndicator && bizIndicator.isCorrect !== null && bizIndicator.updatedOn && (
                        <Box>
                          Updated on <br />
                          {bizIndicator ? moment(bizIndicator.updatedOn).format('MM/DD/YYYY') : ''}
                        </Box>
                      )}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
          <CompanyInformation
            setDisable={setDisable}
            onChange={(changes, type) => handleDataChange(changes, type)}
            descriptiveInfo={descriptiveTabInfo}
          />
          <ZendeskLink />
          {snackData.isOpen && <Snackbar isOpen={true} type={snackData.type} message={snackData.message} />}
        </Box>
      ) : (
        <Box display="flex" justifyContent="center" alignItems="center" height="50vh">
          <ThreeDotsLoadingSpinner width="60px" />
        </Box>
      )}
    </>
  )
}

export default DescriptiveInformation;